import { render, staticRenderFns } from "./PartsType.vue?vue&type=template&id=2b1bb44e&"
import script from "./PartsType.vue?vue&type=script&lang=js&"
export * from "./PartsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports